import { render, staticRenderFns } from "./TenantSummary.vue?vue&type=template&id=1bc34881&scoped=true"
import script from "./TenantSummary.vue?vue&type=script&lang=js"
export * from "./TenantSummary.vue?vue&type=script&lang=js"
import style0 from "./TenantSummary.vue?vue&type=style&index=0&id=1bc34881&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc34881",
  null
  
)

export default component.exports